import PVChart from '../../common/pv-chart'

$(() => {
  if (!$('#owner-requests_show').length) {
    return
  }

  new PVChart($('#pv'))
})